import React from 'react';
import { useApp } from '../context/AppContext';

const DataLoadingBar = () => {
  const { isLoading, loadError } = useApp();

  if (!isLoading || loadError) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading data"
      style={{
        height: '3px',
        background: 'var(--primary, #4f8df3)',
        opacity: 0.8
      }}
    />
  );
};

export default DataLoadingBar;
